import React, { useState,useContext, useEffect } from 'react';
import DynamicIcon from '../../components/dynamicicon';
import JisButton from '../../components/controls/jisButton';
import JisCheckbox from '../../components/controls/jisCheckbox';
import { ShareContext } from '../../context/ShareContext'
import * as Constants from '../../constants';
import * as Services from '../../services';
import JisTabButton from '../../components/controls/jisTabButton';
import BackLoader from '../../components/backloader';
import JisDialog from '../../components/dialog';
import JisDialogForm from '../../components/formdialog';

function GazetteSetup() {
 const {  activePage, token, setIsExpired,setAlert,frequentData} = useContext(ShareContext);
      const [selected, setSelected] = useState({});
      const [tab, setTab] = useState('updategazette');
      const [loading, setLoading] =useState(false);
      const [filingType,setFilingType]=useState('litigation');
      const [gazettes, setGazettes]= useState([]);
        const [map_gazettes, setMapGazettes]= useState([]);
      const [activeGaz, setActiveGaz] = useState(null);
      const [gazetteLines, setGazetteLines] = useState([]);
      const [activeLine, setActiveline]=useState(null);
      const [categoryid,setCategoryid] = useState(0);
      const [err,setErr] = useState('');
      const [selectedRows, setSelectedRows] = useState(new Set());
      const [selectedItems, setSelectedItems] = useState({});
      const [serverMap, setServerMap] = useState(new Set());
      const[isOpenGaz, setOpenGaz] =useState(false);
      const[isOpenLine, setOpenLine] =useState(false);
      const [activeIndex, setActiveIndex] = useState(-1)
      const [gaz, setGaz] = useState({id:0,title:''})
      const [line, setLine] = useState({id:0,title:''})

   useEffect(() => {
     // setActivePage({title:'Manage Role'});
 
      onLoadSpecs();
    }, []);

    useEffect(() => {
     // setActivePage({title:'Manage Role'});
        if(tab=="mapgazette"){

            onLoadGazette();
        }
    }, [tab]);
   useEffect(() => {
     // setActivePage({title:'Manage Role'});
        if(tab=="mapgazette"){
            onLoadMaps();

        }
    }, [categoryid]); 

   useEffect(() => {
     // setActivePage({title:'Manage Role'});
      onLoadSpecs();
    }, [filingType]);

useEffect(() => {
     // setActivePage({title:'Manage Role'});
      onLoadLines();
    }, [activeGaz?.id]);

     const onLoadSpecs= async()=>{
        //for account registration
        const ftypeid=filingType=='litigation'?1:2;
        try {
          setLoading(true);
            const resp = await fetch(`${Constants.apiUrl}/setup/gazette/${ftypeid}/specifications`, { 
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
              },
            });
            setLoading(false);
            const data = await resp.json();
           setGazettes(data.gazettes);
           setGazetteLines([]);
           
          } catch (error) {
            setLoading(false);
            console.error(error);
            
          }
    }
       const onLoadLines= async()=>{
        //for account registration
       
        try {
          setLoading(true);
            const resp = await fetch(`${Constants.apiUrl}/setup/gazette/specifications/${activeGaz?.id}`, { 
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
              },
            });
            setLoading(false);
            const data = await resp.json();
           setGazetteLines(data.lines);
           
          } catch (error) {
            setLoading(false);
            console.error(error);
            
          }
    }

     const check = (id, row) => {
      
        const updatedSelectedRows = new Set(selectedRows);
        /* const updatedSelectedItems = { ...selectedItems }; */

        // Toggle the selection state for the clicked row
        if (updatedSelectedRows.has(id)) {
            updatedSelectedRows.delete(id);
           // delete updatedSelectedItems[id];
            //check if item is on server already
            if(serverMap.has(id)){
                //delete on server
                onDeleteMap(id);
            }

        } else {
            updatedSelectedRows.add(id);
           // updatedSelectedItems[id] = row;
        }

        setSelectedRows(new Set(updatedSelectedRows));
      //  setSelectedItems(updatedSelectedItems);


    };
const onLoadMaps= async()=>{
        //for account registration
        try {
            setLoading(true);
            const resp = await fetch(`${Constants.apiUrl}/setup/gazette-mapping/${categoryid}`, {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Authorization':  `Bearer ${token}`,
              },
            });
            
            const data = await resp.json();
            setLoading(false);
            console.log(data);
            if (data.code === 0) {
                
                setSelectedRows(new Set(data.ids));
                setServerMap(new Set(data.ids));

            }else {    
            }
          } catch (error) {
            setLoading(false);
            console.error(error);
            
          }
    } 

      const onLoadGazette= async()=>{
            //for account registration
          //  console.log(`the calling url ${url}`);
       
            try {
                setLoading(true);
                const resp = await fetch(`${Constants.apiUrl}/setup/gazette-mapping`, { 
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json',
                    'Authorization':  `Bearer ${token}`,
                  },
                });
                
                const data = await resp.json();
                setLoading(false);
                console.log(data);
                if (data.code == 0) {
                 
                    var gazlist=[];
                    //buld dummy 
                    data.gazettes.filter((e)=>e.isActive).forEach(gaz => {
                     var idx=   gazlist.findIndex( function(el){return el.id==gaz.gazetteId});
                     if(idx==-1){
                        //new specification
                        var idsp= data.specs.findIndex( function(el){return el.id==gaz.gazetteId});
                       
                        if(idsp==-1){
                          //  console.log('idsp index '+idsp);
                          //  console.log('cannot find specification for this one');
                          //  console.log(gaz)
                        }else{
                            var spobj={id:data.specs[idsp].id, name:data.specs[idsp].title, items:[]}
                        spobj.items.push( { ...gaz,qty:1});
                        gazlist.push(spobj);
                        }
                            
                        
                     }else{
                        gazlist[idx].items.push( { ...gaz,qty:1});
                     }
    
                    });
                    console.log('constructed dummy');
                    console.log(gazlist)
                    setMapGazettes(gazlist);
                    
                   
                }else {    
                }
              } catch (error) {
                setLoading(false);
                console.error(error);
                
              }
        }

    const onSaveMap= async()=>{
        //for account registration
        try {
            setLoading(true);
            var obj=Array.from(selectedRows);
            const resp = await fetch(`${Constants.apiUrl}/setup/gazette-mapping/${categoryid}`, {
              method: 'POST',
              body: JSON.stringify(obj),
              headers: {
                'Content-Type': 'application/json',
                'Authorization':  `Bearer ${token}`,
              },
            });
            
            const responseData = await resp.json();
            setLoading(false);
            console.log(responseData);
            if (responseData.code === 0) {
            
             //setServerMap(new Set(selectedRows)) ;
             setAlert({open:true, title:'Mapping', subtitle:'Mapping saved successfully'})
            }else {
              
            }
          } catch (error) {
            setLoading(false);
            console.error(error);
            
          }
    }

    const onDeleteMap= async(mapid)=>{
        //for account registration
        try {
            setLoading(true);
            // var obj=Array.from(selectedRows);
            const resp = await fetch(`${Constants.apiUrl}/setup/gazette-mapping-remove/${categoryid}/${mapid}`, {
              method: 'POST',
            //   body: JSON.stringify(obj),
              headers: {
                'Content-Type': 'application/json',
                  Authorization: `Bearer ${token}`,
              },
            });
            
            const responseData = await resp.json();
            setLoading(false);
            console.log(responseData);
            if (responseData.code === 0) {
             console.log('delete done..........');
  
            }else {
              
            }
          } catch (error) {
            setLoading(false);
            console.error(error);
            
          }
    }
 const LineChange = (e) => {
    setLine({...line, [e.target.name]: e.target.value})
}
    const onEditSpec=(spec,index)=>{
        console.log('on edit spec')
        setGaz(spec);
        setActiveIndex(index);
        setOpenGaz(true);
    }
        const onEditItem=(item,index)=>{
             console.log('on edit item')
             console.log(item);
        setLine(item);
        setActiveIndex(index);
        setOpenLine(true);
    }
 const onSaveGaz= async(e)=>{
        //for account registration
        e.preventDefault();
        try {
            setLoading(true);
            
            const resp = await fetch(`${Constants.apiUrl}/setup/gazette`, {
              method: 'POST',
              body: JSON.stringify(gaz),
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
              },
            });
            
            const data = await resp.json();
            setLoading(false);
            console.log(data);
            if (data.code === 0) {
                setOpenGaz(false);
                setAlert({open:true, title:'Saved specification', subtitle:"The Specification is saved"});
                if(gaz.id==0){
                    //this is new, just add to the list
                    var _gass=gazettes;
                    _gass.push({...gaz, id:data.id})
                    setGaz({id:0});
                    setGazettes(_gass);
                    
                    
                }else{
                    //update the one that is there already
                    var _gass=gazettes;
                    _gass[activeIndex]={...gaz};
                    setGazettes(_gass);
                }
             
            }else if(data.code==-10){
                    setIsExpired(true);
                }
                else {
              
            }
          } catch (error) {
            setLoading(false);
            console.error(error);
            
          }
    }
    const onSaveLine= async(e)=>{
        e.preventDefault();
        //for account registration
        //check isUpload is set
        var _nline={...line,isUpload:line.isUpload??false}; // to take care of isUpload null instance
        try {
            setLoading(true);
            
            const resp = await fetch(`${Constants.apiUrl}/setup/gazette/${activeGaz.id}/line`, {
              method: 'POST',
              body: JSON.stringify(_nline),
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
              },
            });
            
             const data = await resp.json();
            setLoading(false);
            console.log(data);
            if (data.code === 0) {
                setOpenLine(false);
                setAlert({open:true, title:'Saved Item', subtitle:"The Specification is saved"});
                if(line.id==0){
                    //this is new, just add to the list
                    var _gass=gazetteLines;
                    _gass.push({...line, id:data.id})
                    setLine({id:0});
                    setGazetteLines(_gass);
                    
                    
                }else{
                    //update the one that is there already
                    var _gass=gazetteLines;
                    _gass[activeIndex]={...line};
                    setGazetteLines(_gass);
                }
             
            }else if(data.code==-10){
                    setIsExpired(true);
                }
          } catch (error) {
            setLoading(false);
            console.error(error);
            
          }
    }

    const onNewGaz=()=>{
        const ftypeid=filingType=='litigation'?1:2;
        setGaz({id:0,filingTypeId:ftypeid});
        setOpenGaz(true);
    }

    const onNewLine=()=>{
        setLine({id:0,gazetteId:activeGaz.id});
        setOpenLine(true);
    }

  return (
    <div>
        <div className='tab_body'>
            <div className='tab_section'>
                 <JisTabButton code="updategazette" isActive={tab=='updategazette'} isRoleBased={false}  title="Add/Edit Gazette Item"  onClick={()=> setTab('updategazette')}/>
                 <JisTabButton code="mapgazette" isActive={tab=='mapgazette'} isRoleBased={false}  title="Map Gazette Item"   onClick={()=> setTab('mapgazette')}/>
            </div>
           {tab=='updategazette' && <div className='view'>
            <div  className='side-tabs-container'>
                <div  className='side-tabs' >
                     <div className={`selected ${filingType=='litigation'?'active':''}`} onClick={()=>setFilingType('litigation')}>Litigation</div>
                     <div className={`selected ${filingType=='adr'?'active':''}`} onClick={()=>setFilingType('adr')}>ADR</div>
                </div>

                <div className='tab-content'>
               
                    <div style={{display:'flex'}}>
                        <div style={{flex:1}}>
                           <div style={{display:'flex', justifyContent:'space-between'}}><h3>Specification</h3> <JisButton onClick={onNewGaz}>Add Specification</JisButton></div> 
                            <div className='maxheight'>
                                
                              {gazettes?.map((opt,index) => (
                                <div key={opt.id} className={`selected ${activeGaz?.id==opt.id?'active':''}`}
                                onClick={()=> setActiveGaz(opt)}>
                                    {opt.title}
                                    <div className='general-space'>
                                        <span>{opt?.isActive?'Visible':'Not Visible'}</span>
                                        <span>Rank: {opt?.rank}</span>
                                        <span onClick={()=>onEditSpec(opt,index)}><DynamicIcon iname="edit" /> Edit</span>
                                    </div>
                                </div>
                                ))}  
                            </div>
                        </div>
                        <div style={{flex:1}}>
                         {activeGaz!=null && <div style={{display:'flex', justifyContent:'space-between'}}><h3>{activeGaz?.title}</h3>
                         <JisButton onClick={onNewLine}>Add Item</JisButton></div> }  
                            <div className='maxheight'>
                                
                              {gazetteLines?.map((opt,index) => (
                                <div key={opt.id} className={`selected ${activeLine?.id==opt.id?'active':''}`}>
                                    {opt.title} {opt.id}
                                    <hr></hr>
                                    <div  className='general-space'>
                                        <span>{opt?.isActive?'Visible':'Not Visible'}</span>
                                        <span>Rank: {opt?.rank}</span>
                                        <span>{opt?.itemType}</span>
                                        <span>{opt?.itemType}</span>
                                       {opt?.isUpload && <span>Document Is Required</span>}
                                       {opt?.isDialog && <span>Show Dialog</span>} 
                                       {opt?.isClaimAmount && <span>Has Claim Amount</span>}   
                                        <span>Fee: {Constants.formatCurrency(opt?.fee) }</span>
                                        {opt?.permissionRequired && <span>Permission Required</span>}
                                         {opt?.isAssociated && <span>Judicial Seal**</span>} 
                               
                                        <span onClick={()=>onEditItem(opt,index)}><DynamicIcon iname="edit" /></span>
                                    </div>
                                   {opt.dialogMsg && <div  className='general-space'><div>Dialog Msg: {opt.dialogMsg}</div> </div>}  
                                </div>
                                ))}  
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            </div>} 
           {tab=='mapgazette' && <div className='view'>
            <div  className='side-tabs-container'>
                <div  className='side-tabs' >
                     <div className={`selected ${filingType=='litigation'?'active':''}`} onClick={()=>setFilingType('litigation')}>Litigation</div>
                     <div className={`selected ${filingType=='adr'?'active':''}`} onClick={()=>setFilingType('adr')}>ADR</div>
                </div>

                <div className='tab-content'>
                   
                    <div style={{display:'flex'}}>
                        <div style={{flex:1}}>
                          
                            {frequentData.casecategories?.map((opt) => (
                                <div key={opt.id} className={`selected ${categoryid==opt.id?'active':''}`} onClick={()=>setCategoryid(opt.id)}>
                                    {opt.categoryTitle}<br/>
                                    <span>{Constants.getItemById(frequentData?.casetype,opt?.caseTypeId)?.caseType1}</span>
                                </div>
                                ))} 
                        </div>
                        <div style={{flex:2}}>
                          
                            <div>
                                <div className='gazette-list'>
    
        <div className="body">
      
            <div className="table-container maxheight">
                <table>
                    <thead>
                        <tr>
                            <th colSpan='2'>Select Specification {map_gazettes?.length}</th>
                           
                            <th>Document Required</th>
                         
                        </tr>
                    </thead>
                    {map_gazettes?.length>0 &&
                        map_gazettes?.map((item, id) => { return (
                            
                            <tbody key={id}  >
                                <tr>
                                    <td className='span' colSpan='3'>
                                        {item.name} 
                                    </td>
                                    <td className='span'>
                                        
                                    </td>
                                </tr>   
                                {
                                    item?.items?.map((row, idx) => { return (
                                        <tr className={'specific-row'} key={idx}>
                                            <td>
                                                {<input 
                                                    type="checkbox" 
                                                    className='check'
                                                    id={row.id}
                                                    onClick={() => check(row.id, row)}
                                                    defaultChecked={selectedRows.has(row.id)}
                                                    checked={selectedRows.has(row.id)}
                                                   
                                                />}
                                               
                                            </td>
                                           {
                                           <td className='specification'>{row.title}  {row.itemType=='External'?'':'Internal'} ({row.id}) </td>
                                        } 
                                            <td className='document-upload'>
                                                {row.isUpload  ? <p>Document Required</p> : ''} 
                                                
                                            </td>
                                            
                                        </tr>
                                    )})
                                }
                            </tbody>
                        )})
                    }
                </table>
            </div>
         

            <div className="total-pay">
                <div className="reset-back">
                    <JisButton  iname="refresh">Reset Selection</JisButton>
                    <JisButton  iname="save" onClick={onSaveMap}>Save Selection</JisButton>
                </div>
           
            </div>
        </div>
            
    
    </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>}


        </div>
        <BackLoader open={loading}  />
           
 


 
          {isOpenGaz && 
          <JisDialogForm title="Specificastion" onClose={()=> setOpenGaz(false)}>
                            <form onSubmit={onSaveGaz}>
                                <div>
                               
                                  <div  className="input-group">
                                    <label> Title</label>
                                    <div className='input-wrapper'>
                                     
                                    <input
                                        placeholder='Title'
                                        name="title"
                                        value={gaz.title}
                                        required={true}
                                        onChange={(e)=>setGaz({...gaz, title:e.target.value})}
                                    />
                                    </div>
                                </div> 
                                <div  className="input-group">
                                    <label> Rank</label>
                                    <div className='input-wrapper'>
                                        <DynamicIcon iname="shield-half" />
                                    <input
                                        placeholder='Rank'
                                        name="rank"
                                        value={gaz.rank}
                                        required={true}
                                        type='number'
                                        onChange={(e)=>setGaz({...gaz, rank:e.target.value})}
                                    />
                                    </div>
                                </div>
                                <JisCheckbox label="Check if its visible" value={gaz.isActive} onChange={(e)=> setGaz({...gaz, isActive:e})}/>
                                  <JisButton type="submit">Save </JisButton>     
                                  <JisButton type="button" onClick={()=> setOpenGaz(false)}>Cancel </JisButton>             
                              </div>
                               </form>
                </JisDialogForm>} 

         
           {isOpenLine && <JisDialogForm title="Gazette Item" onClose={()=> setOpenLine(false)}>
          <div>
                <form onSubmit={onSaveLine}>
                                <div>
                               
                                  <div  className="input-group">
                                    <label> Title</label>
                                    <div className='input-wrapper'>
                                        <DynamicIcon iname="captions" />
                                    <input
                                        placeholder='Title'
                                        name="title"
                                        value={line.title}
                                        required={true}
                                        onChange={LineChange}
                                    />
                                    </div>
                                </div> 
                                <div style={{display:'flex'}}>
                                <div  className="input-group">
                                    <label> Fee</label>
                                    <div className='input-wrapper'>
                                        <DynamicIcon iname="banknote" />
                                    <input
                                        placeholder='Fee'
                                        name="fee"
                                        value={line.fee}
                                        required={true}
                                        onChange={LineChange}
                                    />
                                    </div>
                                </div>
                                 <div  className="input-group">
                                    <label> Rank</label>
                                    <div className='input-wrapper'>
                                        <DynamicIcon iname="arrow-down-up" />
                                    <input
                                        placeholder='Rank'
                                        name="rank"
                                        value={line.rank}
                                        required={true}
                                        onChange={LineChange}
                                    />
                                    </div>
                                </div>
                                </div>
                                <div style={{display:'flex'}}>
                                     <JisCheckbox label="Check if its visible" value={line.isActive} onChange={(e)=> setLine({...line, isActive:e})}/>
                                      <JisCheckbox label="Check if it require document" value={line.isUpload} onChange={(e)=> setLine({...line, isUpload:e})}/>   
                                </div>
                                <div className="select-group">
                                    <label> Item Type <span className="required">*</span> </label>
                                    <select name="itemType" value={line.itemType} required={true} onChange={LineChange} >
                                        <option value="">Select </option>
                                        <option value="Internal">Internal </option>
                                        <option value="External">External </option>
                                    </select>
                            </div>
                                <div style={{display:'flex'}}>
                                    <JisCheckbox label="Check if show dialog" value={line.isDialog} onChange={(e)=> setLine({...line, isDialog:e})}/>
                            {line.isDialog && 
                            <>
                            <div  className="input-group">
                                    <label> Dialog Msg</label>
                                    <div className='input-wrapper'>
                                        <DynamicIcon iname="captions" />
                                    <input
                                        placeholder='Dialog msg'
                                        name="dialogMsg"
                                        value={line.dialogMsg}
                                        required={true}
                                        onChange={LineChange}
                                    />
                                    </div>

                                </div>
                               {/*  <div  className="input-group">
                                    <label> Claim Placeholder</label>
                                    <div className='input-wrapper'>
                                        <DynamicIcon iname="captions" />
                                    <input
                                        placeholder='The placeholder'
                                        name="claimHolder"
                                        value={line.claimHolder}
                                        required={true}
                                        onChange={LineChange}
                                    />
                                    </div>
                                </div> */}
                            </>
                            }   
                                </div>
                                <div>
                                  <JisCheckbox label="Check If Permission Required to Append Instrument" value={line.permissionRequired} onChange={(e)=> setLine({...line, permissionRequired:e})}/>
                                </div>
                                <div>
                                  <JisCheckbox label="Check If Judicial Seal is Required" value={line.isAssociated} onChange={(e)=> setLine({...line, isAssociated:e})}/>
                                </div>
                                <div style={{display:'flex'}}>
                                    <JisCheckbox label="Check if claim amount is required" value={line.isClaimAmount} onChange={(e)=> setLine({...line, isClaimAmount:e})}/>
                            {/* {line.isClaimAmount && <div  className="input-group">
                                    <label> Amount Placeholder</label>
                                    <div className='input-wrapper'>
                                        <DynamicIcon iname="captions" />
                                    <input
                                        placeholder='The placeholder'
                                        name="amountHolder"
                                        value={line.amountHolder}
                                        required={true}
                                        onChange={LineChange}
                                    />
                                    </div>
                                </div>} */}   
                                </div>
                                <div style={{display:'flex'}}>

                                </div>
                               
                                  <JisButton type="submit">Save </JisButton>     <JisButton type="button" onClick={() =>setOpenLine(false)}>Cancel </JisButton>             
                              </div>
                               </form>
          </div>
</JisDialogForm>}             
                 
    </div>
  );
}

export default GazetteSetup;